import { render } from "./upload-avatar.vue?vue&type=template&id=6344f8cc&ts=true"
import script from "./upload-avatar.vue?vue&type=script&lang=ts"
export * from "./upload-avatar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__